import { render } from "./BannerLoader.vue?vue&type=template&id=12ba0a6d"
import script from "./BannerLoader.vue?vue&type=script&lang=js"
export * from "./BannerLoader.vue?vue&type=script&lang=js"

import "./BannerLoader.vue?vue&type=style&index=0&id=12ba0a6d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__